import { SxProps } from "@mui/material";

export const sxError: SxProps = {
    color: '#D84141',
    fontSize: '12px'
}

export const sxRadioButton: SxProps = {
    marginBottom: '24px'
}

export const sxRadio: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px'
    } 
}